import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppFilter } from 'src/modules/shared';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import { FinanceService } from '../../../services';
import { FundWalletModal } from 'src/modules/features/contractor/modals';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}
@Component({
  selector: 'app-wallet-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss'],
})
export class WalletTransactionsComponent {
  filter: AppFilter = new AppFilter();
  pendingFundingFilter: AppFilter = new AppFilter();
  pendingWithdrawalFilter: AppFilter = new AppFilter();
  baseUrl = environment.API_SERVER;
  pending: boolean;
  pendingTwo: boolean;
  pendingThree: boolean;

  success: any;
  error: any;
  selectedCurrencyId;
  activeCurrency;
  currencyCode;

  links = [
    {
      name: 'Transactions',
      link: '/contractor/wallet/transactions',
    },
    {
      name: 'Withdrawal Requests',
      link: '/contractor/wallet/withdrawal-request',
    },
    // {
    //   name: 'Bank Details Change Requests',
    //   link: '/contractor/wallet/change-bank-details',
    // },
  ];
  actionPerformed = [
    {
      optionId: 'OKAY',
      optionName: 'SUCCESSFUL',
    },
    // {
    // 	optionId: "AWAITING_PAYMENT"||"AWAITING_WITHDRAWAL",
    // 	optionName: "PENDING",
    // },
    {
      optionId: 'FAILED',
      optionName: 'FAILED',
    },
  ];

  requestType = [
    {
      optionId: 'PAYMENT',
      optionName: 'PAYMENT',
    },
    {
      optionId: 'WITHDRAWAL',
      optionName: 'WITHDRAWAL',
    },
  ];

  public headers: IHeaders[] = [
    {
      field: 'transactionRef',
      label: 'Transaction ID',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'transactionTag',
      label: 'Description',
      type: 'select',
      op: 'eq',
      choices: this.requestType,
      data: '',
    },
    // {
    // 	field: "creditAmount",
    // 	label: "Credit",
    // 	type: "number",
    // 	op: "cn",
    // 	data: "",
    // },
    // {
    // 	field: "debitAmount",
    // 	label: "Debit",
    // 	type: "text",
    // 	op: "cn",
    // 	data: "",
    // },
    {
      field: 'status',
      label: 'Status',
      type: 'select',
      op: 'eq',
      choices: this.actionPerformed,
      data: '',
    },
    {
      field: 'dateCreated',
      label: 'Transaction Date',
      type: 'date',
      op: 'ge',
      data: '',
    },
  ];

  searchFilter = {
    groupOp: 'or',
    rules: [
      {
        field: 'transactionRef',
        op: 'cn',
        data: '',
        type: 'text',
      },
      {
        field: 'transactionTag',
        op: 'eq',
        data: '',
        type: 'select',
      },
      // {
      // 	field: "creditAmount",
      // 	op: "cn",
      // 	data: Number("0"),
      // 	type: "number",
      // },

      // {
      // 	field: "debitAmount",
      // 	op: "cn",
      // 	data: Number("0"),
      // 	type: "text",
      // },

      {
        field: 'status',
        op: 'eq',
        type: 'select',
        data: '',
      },
      {
        field: 'dateCreated',
        op: 'ge',
        type: 'date',
        data: '',
      },
    ],
  };

  public pendingTablesHeaders: IHeaders[] = [
    {
      field: "gatewayTransactionRefId",
      label: "Transaction ID",
      type: "text",
      op: "cn",
      data: "",
    },
    // {
    //   field: "description",
    //   label: "Description",
    //   type: "text",
    //   op: "eq",
    //   data: "",
    // },
    // {
    // 	field: "totalAmount",
    // 	label: "Amount",
    // 	type: "number",
    // 	op: "cn",
    // 	data: "",
    // },
    // {
    // 	field: "unitAmount",
    // 	label: "Charges",
    // 	type: "text",
    // 	op: "cn",
    // 	data: "",
    // },
    // {
    //   field: "status",
    //   label: "Status",
    //   type: "select",
    //   op: "eq",
    //   choices: this.actionPerformed,
    //   data: "",
    // },
    {
      field: "dateCreated",
      label: "Transaction Date",
      type: "date",
      op: "ge",
      data: "",
    },
  ];

  pendingTablesSearchFilter = {
    groupOp: 'or',
    rules: [
      {
        field: 'gatewayTransactionRefId',
        op: 'cn',
        data: '',
        type: 'text',
      },
      {
        field: 'description',
        op: 'eq',
        data: '',
        type: 'text',
      },
      // {
      // 	field: "totalAmount",
      // 	op: "cn",
      // 	data: Number("0"),
      // 	type: "number",
      // },

      // {
      // 	field: "unitAmount",
      // 	op: "cn",
      // 	data: Number("0"),
      // 	type: "text",
      // },

      // {
      //   field: 'status',
      //   op: 'eq',
      //   type: 'select',
      //   data: '',
      // },
      {
        field: 'dateCreated',
        op: 'ge',
        type: 'date',
        data: '',
      },
    ],
  };

   public pendingTablesTwoHeaders: IHeaders[] = [
    {
      field: "transactionId",
      label: "Transaction ID",
      type: "text",
      op: "cn",
      data: "",
    },
    {
      field: "dateCreated",
      label: "Transaction Date",
      type: "date",
      op: "ge",
      data: "",
    },
  ];

  pendingTablesTwoSearchFilter = {
    groupOp: 'or',
    rules: [
      {
        field: 'transactionId',
        op: 'cn',
        data: '',
        type: 'text',
      },
      {
        field: 'dateCreated',
        op: 'ge',
        type: 'date',
        data: '',
      },
    ],
  };

	transactions = [];
	pendingFundingTransactions = [];
	pendingWithdrawalTransactions = [];

  totalItems: number = this.transactions.length;
  tabelTwoTotalItems: number = this.pendingFundingTransactions.length;
  tableThreeTotalItems: number = this.pendingWithdrawalTransactions.length;
	rows: number = 10;
	tableTwoRows: number = 10;
	tableThreeRows: number = 10;

  currentPage: number = 1;
  currentPageForTableTwo: number = 1;
  currentPageForTableThree: number = 1;
	maxSize: number = 5;
	user = JSON.parse(localStorage.getItem("user")).organizationId.jpaContractor;
  nccId = this.user.nccId;
  appUserId;
	companyName = this.user.companyName;
	account;

  transactionStatus;
  transactionMessage;
  transactionRrr;
  message: string;

  unsubscribe$: Subject<void> = new Subject();

  constructor(
    private router: Router,
    private location: Location,
    private modalService: SuiModalService,
    private walletSvc: EwalletService,
    private financeService: FinanceService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.appUserId = JSON.parse(localStorage.user).appUserId;
    this.selectedCurrencyId = this.route.snapshot.paramMap.get("id");
    if (this.selectedCurrencyId == 'dollar') {
      this.selectedCurrencyId = localStorage.getItem('usDollarId');
    }
    localStorage.setItem("selectedCurrencyId", this.selectedCurrencyId);
		this.getCurrencies();
		this.getTransactions(this.filter);
		this.getPendingFundingTransactions(this.pendingFundingFilter);
		// this.getPendingWithdrawalTransactions(this.pendingWithdrawalFilter);
		this.getBalancesByCurrency();

    // handle route query parameters
    this.transactionStatus = this.route.snapshot.queryParamMap.get('status');
    this.transactionRrr = this.route.snapshot.queryParams['rrr'];

    this.message = this.route.snapshot.queryParamMap.get('message');
    this.transactionRrr
      ? console.log(this.transactionStatus, this.message, this.transactionRrr)
      : '';

		// if(this.transactionStatus == true){
    if (this.message) {
      this.transactionMessage = `
                        Your payment using the RRR - ${this.addHyphen(
        this.transactionRrr
      )} has been successfully processed
                        and will appear in your account once it is approved by the Administrator.
                        To review the status of your payment, please
                      `;
    } else if (this.router.url.includes('/contractor/transactions/dollar')) {
      this.transactionMessage = `
                        Your payment has been successfully processed
                        and will appear in your account once it is approved by the Administrator.
                        To review the status of your payment, please
                      `;
    }
	}

  getBalancesByCurrency() {
    this.pending = true;

    let filter = new AppFilter({
      sidx: 'walletCreatedDate',
      sord: 'desc',
      rows: 4000,
    });

    this.walletSvc
      .getBalancesByCurrency({
        currencyId: this.selectedCurrencyId,
        params: filter,
      })
      .subscribe({
        next: (res: any) => {
          res?.rows.forEach((item) => {
            if (
              item.companyName === this.companyName &&
              item.currencyId === this.selectedCurrencyId
            ) {
              this.account = item;
            }
          });

          this.pending = false;
        },
        error: (error: any) => {
          console.log(error);
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        },
      });
  }

  goBack() {
    this.location.back();
  }

  addHyphen(str: string): string {
    let formatted;
    if (str != null) {
      formatted = str.match(/.{1,4}/g).join('-');
    }
    return formatted;
  }

  checkPaymentStatus() {
    this.router.navigate(['/contractor/payment/list']);
  }

  searchRecords(search) {
    if (search) {
      if (search.toLowerCase() == ('successful' || 'okay')) {
        search = 'OKAY';
      }
      let searchFilter = {
        groupOp: 'or',
        rules: [
          {
            field: 'transactionRef',
            op: 'cn',
            data: '',
            type: 'text',
          },
          {
            field: 'dateCreated',
            op: 'ge',
            type: 'date',
            data: '',
          },
        ],
      };

      searchFilter.rules.forEach((rule) => {
        if (rule.type == 'number') {
          // rule.data = Number(search);
        } else if (rule.type == 'date') {
          if (!this.isInvalidDate(search)) {
            rule.data = new Date(search).toISOString().slice(0, 19).toString();
          } else {
            rule.data = new Date().toISOString().slice(0, 19).toString();
          }
        } else {
          rule.data = search;
        }
      });
      this.filter._search = true;
      this.filter.filters = JSON.stringify(searchFilter);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getTransactions(this.filter);
  }

  isInvalidDate(inputDate) {
    const dateObject = new Date(inputDate);
    return (
      isNaN(dateObject.getTime()) || dateObject.toString() === 'Invalid Date'
    );
  }

  getCurrencies() {
    this.financeService.getCurrenciesConfig({ params: this.filter }).subscribe({
      next: (res: any) => {
        res?.rows.forEach((row: any) => {
          if (this.selectedCurrencyId == row.currencyId) {
            this.activeCurrency = row;
            this.currencyCode = row?.currencyCode;
          }
        });
        console.log(res, 'config for currency');
      },
      error: (error: any) => {
        console.log(error);
      },
    });
  }

  getTransactions(params: any) {
    this.pending = true;
    this.walletSvc
      .getEWalletTransactions({
        nccId: this.nccId,
        currencyId: this.selectedCurrencyId,
        params: params,
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res: any) => {
          this.transactions = res?.rows;
          this.totalItems = res?.records;
          console.log(res);
          this.pending = false;
        },
        error: (error: any) => {
          console.log(error);
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        },
      });
  }

  searchPendingFundingRecords(search) {
    if (search) {
      let searchFilter = {
        groupOp: 'or',
        rules: [
          {
            field: 'gatewayTransactionRefId',
            op: 'cn',
            data: '',
            type: 'text',
          },
          {
            field: 'dateCreated',
            op: 'ge',
            type: 'date',
            data: '',
          },
        ],
      };

			searchFilter.rules.forEach((rule) => {
				if (rule.type == "number") {
					// rule.data = Number(search);
				} else if (rule.type == "date") {
					if (!this.isInvalidDate(search)) {
						rule.data = new Date(search).toISOString().slice(0, 19).toString();
					} else {
						rule.data = new Date().toISOString().slice(0, 19).toString();
					}
				} else {
					rule.data = search;
				}
			});
			this.pendingFundingFilter._search = true;
			this.pendingFundingFilter.filters = JSON.stringify(searchFilter);
		} else {
			this.pendingFundingFilter.filters = {};
			this.pendingFundingFilter._search = false;
		}
		this.currentPageForTableTwo = 1;
		this.pendingFundingFilter.page = this.currentPageForTableTwo;
		this.pendingFundingFilter.sidx = "dateCreated";
		this.getPendingFundingTransactions(this.pendingFundingFilter);
	}

	getPendingFundingTransactions(params: any) {
		this.pendingTwo = true;
		this.walletSvc
			.getPendingEWalletFundingTransactions({
				nccId: this.nccId,
				currencyId: this.selectedCurrencyId,
				params: params,
			})
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe({
				next: (res: any) => {
					this.pendingFundingTransactions = res?.rows;
					this.tabelTwoTotalItems = res?.records;
					console.log(res, "pending funding");
					this.pendingTwo = false;
				},
				error: (error: any) => {
					console.log(error);
					this.pendingTwo = false;
					this.error = error.error.errorMessage
						? error.error.errorMessage
						: error.error.error
						? error.error.error
						: error.error
						? error.error
						: error;
					setTimeout(() => {
						window.location.reload();
					}, 2000);
				},
			});
	}

  searchPendingWithdrawalRecords(search) {
    if (search) {
      let searchFilter = {
        groupOp: 'or',
        rules: [
          {
            field: 'transactionId',
            op: 'cn',
            data: '',
            type: 'text',
          },
          {
            field: 'dateCreated',
            op: 'ge',
            type: 'date',
            data: '',
          },
        ],
      };

			searchFilter.rules.forEach((rule) => {
				if (rule.type == "number") {
					// rule.data = Number(search);
				} else if (rule.type == "date") {
					if (!this.isInvalidDate(search)) {
						rule.data = new Date(search).toISOString().slice(0, 19).toString();
					} else {
						rule.data = new Date().toISOString().slice(0, 19).toString();
					}
				} else {
					rule.data = search;
				}
			});
			this.pendingWithdrawalFilter._search = true;
			this.pendingWithdrawalFilter.filters = JSON.stringify(searchFilter);
		} else {
			this.pendingWithdrawalFilter.filters = {};
			this.pendingWithdrawalFilter._search = false;
		}
		this.currentPageForTableThree = 1;
		this.pendingWithdrawalFilter.page = this.currentPageForTableThree;
		this.pendingWithdrawalFilter.sidx = "dateCreated";
		this.getPendingWithdrawalTransactions(this.pendingWithdrawalFilter);
	}

	getPendingWithdrawalTransactions(params: any) {
		this.pendingThree = true;
		this.walletSvc
			.getPendingEWalletWithdrawalTransactions({
				nccId: this.nccId,
        currencyId: this.selectedCurrencyId,
        appUserId: this.appUserId,
				params: params,
			})
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe({
				next: (res: any) => {
          this.pendingWithdrawalTransactions = res?.rows;
					this.tableThreeTotalItems = res?.records;
					console.log(res, "pending withdrawal");
					this.pendingThree = false;
				},
				error: (error: any) => {
					console.log(error);
					this.pendingThree = false;
					this.error = error.error.errorMessage
						? error.error.errorMessage
						: error.error.error
						? error.error.error
						: error.error
						? error.error
						: error;
					setTimeout(() => {
						window.location.reload();
					}, 2000);
				},
			});
	}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  displayRecords(noOfRows) {
    this.rows = noOfRows;
    this.filter.rows = noOfRows;
    this.getTransactions(this.filter);
  }

  displayPendingFundingRecords(noOfRows) {
    this.tableTwoRows = noOfRows;
    this.pendingFundingFilter.rows = noOfRows;
    this.getPendingFundingTransactions(this.pendingFundingFilter);
  }

  displayPendingWithdrawalRecords(noOfRows) {
    this.tableThreeRows = noOfRows;
    this.pendingFundingFilter.rows = noOfRows;
    this.getPendingWithdrawalTransactions(this.pendingWithdrawalFilter);
  }

  sortRecords(order: string) {
    this.filter.sord = order == 'desc' ? 'desc' : 'asc';
    this.getTransactions(this.filter);
  }

  sortPendingFundingRecords(order: string) {
    this.pendingFundingFilter.sord = order == 'desc' ? 'desc' : 'asc';
    this.getTransactions(this.pendingFundingFilter);
  }

  sortPendingWithdrawalRecords(order: string) {
    this.pendingWithdrawalFilter.sord = order == 'desc' ? 'desc' : 'asc';
    this.getTransactions(this.pendingWithdrawalFilter);
  }

  advancedSearch(search) {
    if (search) {
      this.filter = search;
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getTransactions(this.filter);
    console.log(this.filter);
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: this.currentPage,
      rows: this.rows,
    });
    this.getTransactions(this.filter);
  }

  nextPage(page: number) {
    this.currentPage = page;
    this.filter.page = page;
    this.getTransactions(this.filter);
  }

  advancedSearchForTableTwo(search) {
    if (search) {
      this.pendingFundingFilter = search;
      this.pendingFundingFilter._search = true;
      this.pendingFundingFilter.filters = JSON.stringify(search);
    } else {
      this.pendingFundingFilter.filters = {};
      this.pendingFundingFilter._search = false;
    }
    this.currentPageForTableTwo = 1;
    this.pendingFundingFilter.page = this.currentPageForTableTwo;
    this.pendingFundingFilter.sidx = 'dateCreated';
    this.getPendingFundingTransactions(this.pendingFundingFilter);
    // console.log(this.filter);
  }

  cancelAdForTableTwo() {
    this.pendingFundingFilter = new AppFilter({
      page: this.currentPageForTableTwo,
      rows: this.tableTwoRows,
    });
    this.getPendingFundingTransactions(this.pendingFundingFilter);
  }

  nextPageForTableTwo(page: number) {
    this.currentPageForTableTwo = page;
    this.pendingFundingFilter.page = page;
    this.getPendingFundingTransactions(this.pendingFundingFilter);
  }


  advancedSearchForTableThree(search) {
    if (search) {
      this.pendingWithdrawalFilter = search;
      this.pendingWithdrawalFilter._search = true;
      this.pendingWithdrawalFilter.filters = JSON.stringify(search);
    } else {
      this.pendingWithdrawalFilter.filters = {};
      this.pendingWithdrawalFilter._search = false;
    }
    this.currentPageForTableThree = 1;
    this.pendingWithdrawalFilter.page = this.currentPageForTableThree;
    this.pendingWithdrawalFilter.sidx = 'dateCreated';
    this.getPendingWithdrawalTransactions(this.pendingWithdrawalFilter);
    // console.log(this.filter);
  }

  cancelAdForTableThree() {
    this.pendingWithdrawalFilter = new AppFilter({
      page: this.currentPageForTableThree,
      rows: this.tableThreeRows,
    });
    this.getPendingWithdrawalTransactions(this.pendingWithdrawalFilter);
  }

  nextPageForTableThree(page: number) {
    this.currentPageForTableThree = page;
    this.pendingWithdrawalFilter.page = page;
    this.getPendingWithdrawalTransactions(this.pendingWithdrawalFilter);
  }


  fundWallet() {
    this.modalService.open(new FundWalletModal(this.account));
  }
}
